export default __webpack_public_path__ + "static/media/call.b115909a.svg";